/**
 * Why a part did not reach S3:
 * - `network`: no answer (status 0). The browser blocked the request (an extension, a VPN, a
 *   firewall, CORS) or the connection broke.
 * - `refused`: S3 answered with an error status, or with no ETag.
 * - `unreadable`: the browser cannot read the picked file any more (it moved, changed or is in a
 *   cloud folder that is not on the disk). A retry does not help.
 */
export type MasterPartFailureKind = 'network' | 'refused' | 'unreadable';

export class MasterPartError extends Error {
  constructor(
    readonly kind: MasterPartFailureKind,
    readonly partNumber: number,
    readonly status: number,
    detail: string
  ) {
    super(`Master part ${partNumber}: ${detail}`);
    this.name = 'MasterPartError';
  }
}
